module.exports = __webpack_public_path__ + "img/farming_28.4ea5b728.png";